import CloseIcon from '@mui/icons-material/Close'
import { IconButton, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import * as React from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Notistack } from '../../components/Notistack'
import CheckIcon from './../../assets/icons/Check.svg?react'
import CopyIcon from './../../assets/icons/Copy.svg'

const SUCCESS_MESSAGE = 'Ссылка скопирована'

interface Props {
    open: boolean
    onClose: () => void
    entityId?: string
    entityName: string
    onCopy?: () => void
}

export const ShareDialog: React.FC<Props> = ({ open, onClose, entityId, entityName, onCopy }) => {
    const [openSnackbar, setOpenSnackbar] = React.useState(false)
    const [isCopied, setCopied] = React.useState(false)

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    const handleOnClose = () => {
        onClose()
        setCopied(false)
    }

    const handleCopy = () => {
        if (isCopied) {
            return
        }

        onCopy && onCopy()
        setCopied(true)
        setOpenSnackbar(true)

        setTimeout(() => {
            handleOnClose()
        }, 2000)
    }

    return (
        <>
            <Dialog
                slotProps={{
                    paper: {
                        style: {
                            width: '500px',
                        },
                    },
                }}
                open={open}
                onClose={handleOnClose}>
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0',
                    }}>
                    Публичная ссылка создана
                    <IconButton
                        onClick={handleOnClose}
                        sx={{
                            border: '1px solid #E9EAED',
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="body2" color="#5A5F72">
                            Получившие ссылку пользователи, смогут просматривать только историю
                            этого запроса
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <CopyToClipboard
                        text={`${window.location.origin}/share/${entityName}/?id=${entityId}`}
                        onCopy={handleCopy}>
                        <Button
                            fullWidth
                            startIcon={!isCopied ? <CopyIcon /> : <CheckIcon />}
                            autoFocus
                            variant="contained">
                            {!isCopied ? 'Скопировать' : 'Скопировано'}
                        </Button>
                    </CopyToClipboard>
                </DialogActions>
                <Notistack
                    open={openSnackbar}
                    isError={false}
                    message={SUCCESS_MESSAGE}
                    onClose={handleCloseSnackbar}
                />
            </Dialog>
        </>
    )
}
